import { Navigate } from 'react-router-dom';

import { useUserStateContext } from '@/shared/components/UserStateProvider';
import { getLandingRoute } from '@/shared/services/getLandingRoute';

/**
 * '/' — sends the user to the first page their roles can open.
 *
 * Holds off until the profile is in hand. userProfile is populated in an
 * effect, so there is a render where isLoading is already false and roles are
 * still null; redirecting then would put everyone on the fallback, and a
 * redirect cannot be taken back.
 */
const LandingRedirect = () => {
  const { userProfile, isLoading } = useUserStateContext();

  if (isLoading || !userProfile) {
    return <></>;
  }

  return <Navigate to={getLandingRoute(userProfile.roles)} />;
};

export default LandingRedirect;
